import { render, staticRenderFns } from "./Value.vue?vue&type=template&id=81f5e584&scoped=true&"
import script from "./Value.vue?vue&type=script&lang=ts&"
export * from "./Value.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f5e584",
  null
  
)

export default component.exports